export const environment = {
  production: true,
  gtagTrackingId: 'UA-167901022-1',
  gtagUrl: 'https://www.googletagmanager.com/gtag/js?id='
};
